/**
 * German 404 for an unknown client-side route.
 *
 * Rendered INSIDE the app shell (see the catch-all in App.tsx), so the user keeps
 * the header and navigation and the mistyped URL is not also a logout. Backend
 * paths never reach this component: app/routes/spa.py answers a JSON 404 for its
 * reserved namespaces instead of serving the SPA shell.
 */

import { Link, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';

export function NotFoundPage(): ReactNode {
  const location = useLocation();

  return (
    <div className="notice-panel">
      <div className="code">404</div>
      <h1>Seite nicht gefunden</h1>
      <p>
        Die Adresse <code className="mono">{location.pathname}</code> gehört zu keiner Seite von
        AssetRadar.
      </p>
      <Link to="/">Zurück zum Dashboard</Link>
    </div>
  );
}

export default NotFoundPage;
